import { APP_HEADER_PAGETITLE } from 'variables';

export const language = {
  informacionPractica: {
    tipoPracticaTitle: 'Tipo práctica',
    tipoPracticaDefault: 'Seleccione tipo de práctica',
    sociedadCursoLabel: 'Soc. Curso',
    seleccionCursoPlaceholder: 'Seleccione un curso',
    cursoLabel: 'Curso',
    infoGeneralPracticaTitle: 'Información general de la práctica',
    puestaDisposicion: 'Puesta a disposición',
    tipoServicioLabel: 'Tipo servicio',
    tipoServicioPlaceholder: 'Seleccione tipo servicio',
    vehiculoLabel: 'Vehículo',
    trenLabel: 'Tren',
    turnoLabel: 'Turno',
    cursoPlaceholder: 'Seleccione curso',
    tipoPracticaLabel: 'Tipo práctica',
    tipoPracticaPlaceholder: 'Seleccione tipo práctica',
    detallePractica: 'Detalle de práctica',
    alumnoLabel: 'Alumno',
    alumnoNombre: 'Nombre',
    alumnoTipo: 'Tipo',
    provincia: 'Provincia',
    validacionLabel: 'Validación',
    estadoLabel: 'Estado',
    anularLabel: 'Anular',
    grabarBorradorLabel: 'Grabar borrador',
    reclamarLabel: 'Reclamar',
    rechazarLabel: 'Rechazar',
    enviarLabel: 'Enviar',
    validarLabel: 'Validar',
    auditLabel: 'Auditar',
    observacionesInstructorLabel: 'Observaciones Instructor',
    observationsAlumnLabel: 'Observaciones Alumno',
    modalConfirmRechazar: '¿Seguro que quiere rechazar la práctica?',
    instructorLabel: 'Instructor',
    instructorName: 'Nombre',
    instructorPlaceholder: 'Seleccione un nombre',
    sociedadInstructor: 'Soc. Instructor',
    instructorPlaceholderName: 'Introduzca nombre',
    servicioLabel: 'Servicio',
    aplicarLabel: 'Aplicar',
    dateHastaLabel: 'Hasta',
    dateDesdeLabel: 'Desde',
    hourInicioLabel: 'Inicio',
    hourFinLabel: 'Fin',
    hourFinPlaceholderLabel: 'F. Fin',
    hourInicioPlaceholderLabel: 'F. Inicio',
    minutosLabel: 'Minutos',
    estacionesLabel: 'Estaciones',
    origenLabel: 'Origen',
    destinoLabel: 'Destino',
    origenPlaceholder: 'Seleccione un origen',
    destinoPlaceholder: 'Seleccione un destino',
    jornadaLabel: 'Jornada',
    jornadaPlaceholder: 'Si existe la jornada seleccione',
    crearPracticaLabel: 'Crear práctica',
    limpiar: 'Limpiar Formulario',
    leyendaBorrador:
      'Para guardar borrador todos los campos con asterisco son necesarios.',
    leyendaEnviar:
      'Para enviar una práctica es necesario cumplimentar todos los campos del formulario.',
    '': '',
  },
  listadoPracticas: {
    filtrarLabel: 'Filtrar',
  },
  login: {
    pageTitle: APP_HEADER_PAGETITLE,
    accesoLabel: 'Acceso',
    userLabel: 'Usuario',
    userPlaceholder: 'Introduzca usuario',
    passLabel: 'Contraseña',
    passPlaceholder: 'Introduzca contraseña',
    accederLabel: 'Acceder',
  },
  validations: {
    multiselectEmpty: 'No hay resultados de búsqueda',
    selectEmpty: 'No hay opciones disponibles',
    noOptions: 'No hay opciones disponibles',
    paramsDoesNotMatch:
      'El numero de parámetros pasados no coincide con el número de parámetros que espera la función.',
    dateIsEqualsOrAfterNow:
      'No puede seleccionarse una fecha/hora igual o posterior a este momento.',
    dateIsNotBetween: 'La fecha/hora no está entre los valores deseados.',
    dateIsBeforeStart: 'La fecha/hora es anterior a la fecha/hora inicial.',
    dateIsBeforeOrEqualsStart:
      'La fecha/hora es anterior o igual a la fecha/hora inicial.',
    minutesPracticeHigher480: 'No puede superar 480 minutos',
    obligatoryField: 'campo obligatorio',
  },
  filter: {
    filterName: 'Indique nombre para el filtro',
    sendConfirm: 'Enviar'
  }
};
